import * as React from "react";

function SvgRuler(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 55 12" fill="none" {...props}>
      <path d="M4 0H0v12h4V9h47v3h4V0h-4v3H4V0z" fill="#fff" />
    </svg>
  );
}

export default SvgRuler;
